import React from "react";

const ShoppingIcon = ({ width }) => {
  return (
    <svg
      width={width}
      viewBox='0 0 512 512'
      id='_02_Shopping_App'
      version='1.1'
      xmlns='http://www.w3.org/2000/svg'
      fill='#000000'
    >
      <g id='SVGRepo_bgCarrier' strokeWidth={0} />
      <g
        id='SVGRepo_tracerCarrier'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <g id='SVGRepo_iconCarrier'>
        <style
          type='text/css'
          dangerouslySetInnerHTML={{
            __html:
              " .st0{fill:#FDD367;} .st1{fill:#FEE9B4;} .st2{fill:#FFFFFF;} .st3{fill:#A8B2B4;} .st4{fill:#D3D9D9;} .st5{fill:#7C8B8E;} .st6{fill:#333333;} .st7{fill:#FC8A8A;} .st8{fill:#7BDE9E;} .st9{fill:#FCB0B0;} .st10{fill:#A7EABF;} .st11{fill:#F96364;} .st12{fill:#51D27F;} .st13{fill:#7AD2FA;} .st14{fill:#A5E1FB;} .st15{fill:#4BC3F7;} ",
          }}
        />
        <title />
        <path
          className='st0'
          d='M200.8,508c-0.1,0-0.2,0-0.3,0H43.3c-5.7,0-10.3-4.6-10.3-10.3c0-0.5,0-1,0.1-1.4l21.1-146.1 c0.7-5.1,5.1-8.8,10.2-8.8h78.1v136.7c0,16.5,13.4,29.9,29.9,29.9H200.8z'
        />
        <path
          className='st1'
          d='M84,341.4c-5.1,0-9.4,3.7-10.2,8.8L52.7,496.3c-0.8,5.6,3.1,10.8,8.7,11.6c0.5,0.1,1,0.1,1.4,0.1H43.3 c-5.7,0-10.3-4.6-10.2-10.3c0-0.5,0-1,0.1-1.4l21.1-146.1c0.7-5.1,5.1-8.8,10.2-8.8L84,341.4z'
        />
        <path
          className='st2'
          d='M451.7,33.9v444.2c0,16.5-13.4,29.9-29.9,29.9H172.5c-16.5,0-29.9-13.4-29.9-29.9V33.9 c0-16.5,13.4-29.9,29.9-29.9c0,0,0,0,0,0h249.3C438.3,4,451.7,17.4,451.7,33.9z'
        />
        <path
          className='st3'
          d='M451.7,72.3V33.9c0-16.5-13.4-29.9-29.9-29.9H172.5c-16.5,0-29.9,13.4-29.9,29.9c0,0,0,0,0,0v38.4H451.7z'
        />
        <path
          className='st3'
          d='M142.5,439.7v38.4c0,16.5,13.4,29.9,29.9,29.9h249.3c16.5,0,29.9-13.4,29.9-29.9c0,0,0,0,0,0v-38.4L142.5,439.7 z'
        />
        <path
          className='st4'
          d='M202.8,4c-16.5,0-29.9,13.4-29.9,29.9c0,0,0,0,0,0v38.4h-30.3V33.9C142.6,17.4,156,4,172.5,4c0,0,0,0,0,0 L202.8,4z'
        />
        <path
          className='st4'
          d='M202.7,508h-30.3c-16.5,0-29.9-13.4-29.9-29.9v-38.4h30.3v38.4C172.8,494.6,186.2,508,202.7,508z'
        />
        <path
          className='st5'
          d='M451.7,33.9v38.4h-30.3V33.9C421.4,17.4,408,4,391.5,4h30.3C438.3,4,451.7,17.4,451.7,33.9z'
        />
        <path
          className='st5'
          d='M451.7,439.7v38.4c0,16.5-13.4,29.9-29.9,29.9c0,0,0,0,0,0h-30.3c16.5,0,29.9-13.4,30-29.9v-38.4H451.7z'
        />
        <path
          className='st6'
          d='M345.4,42.1h-96.5c-2.2,0-4-1.8-4-4s1.8-4,4-4h96.5c2.2,0,4,1.8,4,4S347.6,42.1,345.4,42.1z'
        />
        <path
          className='st6'
          d='M367.5,42.1h-6.7c-2.2,0-4-1.8-4-4s1.8-4,4-4h6.7c2.2,0,4,1.8,4,4S369.7,42.1,367.5,42.1L367.5,42.1z'
        />
        <path
          className='st2'
          d='M297.1,493.1c-10.6,0-19.2-8.6-19.2-19.2s8.6-19.2,19.2-19.2c10.6,0,19.2,8.6,19.2,19.2 C316.3,484.5,307.7,493.1,297.1,493.1z'
        />
        <path
          className='st6'
          d='M297.1,450.7c-12.8,0-23.2,10.4-23.2,23.2s10.4,23.2,23.2,23.2c12.8,0,23.2-10.4,23.2-23.2 C320.3,461.1,309.9,450.7,297.1,450.7C297.1,450.7,297.1,450.7,297.1,450.7z M297.1,489.1c-8.4,0-15.2-6.8-15.2-15.2 s6.8-15.2,15.2-15.2c8.4,0,15.2,6.8,15.2,15.2C312.3,482.3,305.5,489.1,297.1,489.1L297.1,489.1z'
        />
        <path
          className='st7'
          d='M167.2,143.2h52v13.7c0,14.3-11.6,26-26,26s-26-11.6-26-26L167.2,143.2z'
        />
        <path
          className='st7'
          d='M427,143.2v13.7c0,14.3-11.6,26-26,26s-26-11.6-26-26v-13.7H427z'
        />
        <path
          className='st7'
          d='M271.1,143.2h52v13.7c0.1,14.3-11.5,26.1-25.8,26.1c-14.3,0.1-26.1-11.5-26.1-25.8c0-0.1,0-0.2,0-0.3V143.2z'
        />
        <path
          className='st8'
          d='M115.3,143.2h52v13.7c0,14.3-11.6,26-26,26c-14.3,0-26-11.6-26-26L115.3,143.2z'
        />
        <path
          className='st8'
          d='M323.1,143.2h52v13.7c0,14.3-11.6,26-26,26s-26-11.6-26-26V143.2z'
        />
        <path
          className='st8'
          d='M219.2,143.2h52v13.7c0,14.3-11.6,26-26,26s-26-11.6-26-26V143.2z'
        />
        <path
          className='st8'
          d='M479,143.2v13.7c0,14.3-11.6,26-26,26s-26-11.6-26-26v-13.7H479z'
        />
        <polygon
          className='st8'
          points='186.6,72.3 167.2,143.2 115.2,143.2 142.4,72.3 '
        />
        <polygon
          className='st7'
          points='230.8,72.3 219.2,143.2 167.2,143.2 186.6,72.3 '
        />
        <polygon
          className='st8'
          points='275,72.3 271.1,143.2 219.2,143.2 230.8,72.3 '
        />
        <polygon
          className='st7'
          points='319.2,72.3 323.1,143.2 271.1,143.2 275,72.3 '
        />
        <polygon
          className='st8'
          points='363.4,72.3 375,143.2 323.1,143.2 319.2,72.3 '
        />
        <polygon
          className='st7'
          points='407.6,72.3 427,143.2 375,143.2 363.4,72.3 '
        />
        <polygon
          className='st8'
          points='451.8,72.3 479,143.2 427,143.2 407.6,72.3 '
        />
        <path
          className='st9'
          d='M199.5,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7C179.8,168.7,187.9,179.1,199.5,182 z'
        />
        <path
          className='st9'
          d='M407.3,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7C387.6,168.7,395.7,179.1,407.3,182 z'
        />
        <path
          className='st9'
          d='M303.4,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7C283.7,168.7,291.8,179.1,303.4,182 z'
        />
        <path
          className='st10'
          d='M147.5,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7 C127.8,168.7,135.9,179.1,147.5,182z'
        />
        <path
          className='st10'
          d='M355.4,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7 C335.6,168.7,343.8,179.1,355.4,182z'
        />
        <path
          className='st10'
          d='M251.4,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7 C231.7,168.7,239.9,179.1,251.4,182z'
        />
        <path
          className='st10'
          d='M459.3,182c-2.1,0.5-4.2,0.8-6.3,0.8c-14.3,0-26-11.6-26-26v-13.7h12.6v13.7 C439.6,168.7,447.7,179.1,459.3,182z'
        />
        <polygon
          className='st10'
          points='154.6,72.3 127.8,143.2 115.3,143.2 142.4,72.3 '
        />
        <polygon
          className='st9'
          points='198.8,72.3 179.8,143.2 179.8,143.2 167.2,143.2 167.2,143.2 186.6,72.3 '
        />
        <polygon
          className='st10'
          points='243,72.3 231.7,143.2 219.2,143.2 230.8,72.3 '
        />
        <polygon
          className='st9'
          points='287.2,72.3 283.7,143.2 271.1,143.2 275,72.3 '
        />
        <polygon
          className='st10'
          points='335.6,143.2 323.1,143.2 319.2,72.3 331.5,72.3 '
        />
        <polygon
          className='st9'
          points='387.6,143.2 375,143.2 363.4,72.3 375.7,72.3 '
        />
        <polygon
          className='st10'
          points='439.6,143.2 427,143.2 407.6,72.3 419.9,72.3 '
        />
        <path
          className='st11'
          d='M219.2,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H219.2z'
        />
        <path
          className='st11'
          d='M427,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H427z'
        />
        <path
          className='st11'
          d='M323.1,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H323.1z'
        />
        <path
          className='st12'
          d='M167.2,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H167.2z'
        />
        <path
          className='st12'
          d='M375,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H375z'
        />
        <path
          className='st12'
          d='M271.1,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H271.1z'
        />
        <path
          className='st12'
          d='M479,143.2v13.7c0,14.3-11.6,26-26,26c-2.1,0-4.2-0.3-6.3-0.8c4.6-1.2,8.7-3.5,12.1-6.9 c4.9-4.9,7.6-11.5,7.6-18.4v-13.7H479z'
        />
        <polygon
          className='st12'
          points='186.6,72.3 167.2,143.2 154.6,143.2 174.3,72.3 '
        />
        <polygon
          className='st11'
          points='230.8,72.3 219.2,143.2 219.2,143.2 206.6,143.2 206.6,143.2 218.6,72.3 '
        />
        <polygon
          className='st12'
          points='275,72.3 271.1,143.2 258.6,143.2 262.8,72.3 '
        />
        <polygon
          className='st11'
          points='323.1,143.2 310.5,143.2 306.9,72.3 319.2,72.3 '
        />
        <polygon
          className='st12'
          points='375,143.2 362.5,143.2 351.2,72.3 363.4,72.3 '
        />
        <polygon
          className='st11'
          points='427,143.2 414.4,143.2 395.4,72.3 407.6,72.3 '
        />
        <polygon
          className='st12'
          points='479,143.2 466.4,143.2 439.6,72.3 451.8,72.3 '
        />
        <path
          className='st13'
          d='M238.3,226.6h117.6c14.3,0,25.8,11.6,25.8,25.8v117.6c0,14.3-11.6,25.8-25.8,25.8H238.3 c-14.3,0-25.8-11.6-25.8-25.8V252.5C212.4,238.2,224,226.6,238.3,226.6C238.3,226.6,238.3,226.6,238.3,226.6L238.3,226.6z'
        />
        <path
          className='st14'
          d='M261.5,395.9h-23.2c-14.3,0-25.8-11.6-25.8-25.8c0,0,0,0,0,0V252.4c0-14.3,11.6-25.8,25.8-25.8c0,0,0,0,0,0 h23.2c-14.3,0-25.8,11.6-25.8,25.8c0,0,0,0,0,0v117.6C235.6,384.3,247.2,395.9,261.5,395.9C261.5,395.9,261.5,395.9,261.5,395.9z'
        />
        <path
          className='st15'
          d='M381.8,252.4v117.6c0,14.3-11.6,25.8-25.8,25.8c0,0,0,0,0,0h-23.2c14.3,0,25.8-11.6,25.8-25.8c0,0,0,0,0,0 V252.4c0-14.3-11.6-25.8-25.8-25.8c0,0,0,0,0,0h23.2C370.2,226.6,381.8,238.2,381.8,252.4C381.8,252.4,381.8,252.4,381.8,252.4z'
        />
        <path
          className='st6'
          d='M355.9,399.9H238.3c-16.5,0-29.8-13.4-29.8-29.8V252.4c0-16.5,13.4-29.8,29.8-29.8h117.6 c16.5,0,29.8,13.4,29.8,29.8v117.6C385.7,386.6,372.4,399.9,355.9,399.9z M238.3,230.6c-12.1,0-21.8,9.8-21.8,21.8v117.6 c0,12.1,9.8,21.8,21.8,21.8h117.6c12.1,0,21.8-9.8,21.8-21.8V252.4c0-12.1-9.8-21.8-21.8-21.8H238.3z'
        />
        <path
          className='st6'
          d='M278.4,306.2c-0.5,0-0.9,0-1.4-0.1c-4.3-0.5-8.1-3-10.2-6.8l-19.3-35.9c-1-1.9-0.3-4.4,1.6-5.4 c1.9-1,4.4-0.3,5.4,1.6l19.3,35.9c1.3,2.5,4.5,3.4,7,2.1c0.6-0.3,1.1-0.7,1.5-1.2l4.8-5.6c4.7-5.5,13-6.1,18.5-1.4 c0.5,0.4,1,0.9,1.4,1.4l4.8,5.6c1.8,2.2,5.1,2.4,7.3,0.6c0.5-0.4,0.9-0.9,1.2-1.5l19.3-35.9c1-1.9,3.5-2.7,5.4-1.6s2.7,3.5,1.6,5.4 l-19.3,35.9c-3.4,6.4-11.4,8.8-17.8,5.3c-1.4-0.8-2.7-1.8-3.7-3L301,296c-1.9-2.2-5.3-2.3-7.4-0.4c-0.1,0.1-0.3,0.3-0.4,0.4 l-4.8,5.6C285.9,304.5,282.3,306.2,278.4,306.2z'
        />
        <path
          className='st6'
          d='M482.9,143c0-0.4-0.1-0.9-0.2-1.3l0-0.1c0,0,0,0,0-0.1l-27-70.5V33.9c0-18.7-15.2-33.9-33.9-33.9H172.5 c-18.7,0-33.9,15.2-33.9,33.9v37.2l-27,70.6c-0.2,0.4-0.2,0.9-0.2,1.3c0,0,0,0.1,0,0.1v13.7c0,15.5,11.9,28.4,27.3,29.8v104.9 c-5.3-2.3-10.9-3.4-16.6-3.4c-23.6,0-42.6,19.1-42.7,42.7v6.6H64.4c-7.1,0-13.2,5.2-14.1,12.2L29.2,495.7c-1.1,7.8,4.3,15,12.1,16.1 c0.7,0.1,1.3,0.1,2,0.1l378.5,0c18.7,0,33.9-15.2,33.9-33.9V186.7c15.4-1.4,27.3-14.3,27.3-29.8v-13.7 C483,143.1,482.9,143.1,482.9,143z M473.1,139.2H430l-1.6-5.9l-15.6-57h36.2L473.1,139.2z M327.1,147.2h44v9.6c0,12.1-9.8,22-22,22 c-12.1,0-22-9.8-22-22L327.1,147.2z M326.9,139.2l-3.4-62.3l0-0.6H360l10.3,62.9L326.9,139.2z M368.1,76.3h36.4l1.6,5.9l15.6,57 h-43.3L368.1,76.3z M379,147.2h44v9.6c0,12.1-9.8,22-22,22c-12.1,0-22-9.8-22-22L379,147.2z M146.5,33.9c0-14.3,11.6-25.9,25.9-25.9 h249.3c14.3,0,25.9,11.6,25.9,25.9v34.4H146.5L146.5,33.9z M319.1,147.2v9.6c0,12.1-9.9,22-22,22c-12.1,0-22-9.8-22-22v-9.6 L319.1,147.2z M275.3,139.2l0-0.6l3.4-62.3h36.6l3.4,62.3l0,0.6H275.3z M172.4,139.2l16.5-60.3l0.7-2.6h36.4l-10.3,62.9L172.4,139.2 z M215.2,147.2v9.6c0,12.1-9.8,22-22,22c-12.1,0-22-9.8-22-22v-9.6H215.2z M223.2,147.2h44v9.6c0,12.1-9.9,22-22,22 c-12.1,0-22-9.8-22-22L223.2,147.2z M223.9,139.2l10.3-62.9h36.6l0,0.6l-3.4,62.3L223.9,139.2z M145.1,76.3h36.2l-16.5,60.3 l-0.7,2.6h-43.1L145.1,76.3z M119.3,156.8v-9.6h44v9.6c0,12.1-9.8,22-22,22C129.1,178.8,119.3,169,119.3,156.8L119.3,156.8z M87.3,330.8c0-19.1,15.5-34.7,34.7-34.7c5.8,0,11.5,1.5,16.6,4.3v37H87.3V330.8z M38.6,501.9c-1.2-1.4-1.7-3.2-1.5-5l21.1-146.1 c0.4-3.1,3.1-5.4,6.2-5.4h14.8v19.4c0,2.2,1.8,4,4,4s4-1.8,4-4v-19.4h51.3v132.7c0,10,4.4,19.5,12.1,25.9H43.3 C41.5,504,39.8,503.2,38.6,501.9z M447.7,478.1c0,14.3-11.6,25.9-25.9,25.9H172.5c-14.3,0-25.9-11.6-25.9-25.9v-34.3h301.1 L447.7,478.1z M447.7,435.7H146.5V186.3c8.7-1.6,16.3-6.9,20.7-14.6c8.2,14.3,26.5,19.3,40.9,11.1c4.6-2.6,8.4-6.5,11.1-11.1 c8.2,14.3,26.5,19.3,40.9,11.1c4.6-2.6,8.4-6.5,11.1-11.1c8.2,14.3,26.5,19.3,40.9,11.1c4.6-2.6,8.4-6.5,11.1-11.1 c8.2,14.3,26.5,19.3,40.9,11.1c4.6-2.6,8.5-6.5,11.1-11.1c8.2,14.3,26.5,19.3,40.9,11.1c4.6-2.6,8.4-6.5,11.1-11.1 c4.4,7.6,12,13,20.7,14.5L447.7,435.7z M475,156.8c0,12.1-9.8,22-22,22c-12.1,0-22-9.8-22-22v-9.6h44L475,156.8z'
        />
      </g>
    </svg>
  );
};

export default ShoppingIcon;
